import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";
import { CaseHistoryTabWrapper, CaseRemarksTabWrapper, CaseNotesHeader } from "components/Homeowner/CaseDetails/CaseNotesParts";

class CaseNotes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMenuId: "caseHistory"
        };

        this.switchMenuItem = (value) => {
            this.setState({ currentMenuId: value });
        };

        this.menuItems = [
            { id: "caseHistory", desc: "Case History" },
            { id: "caseRemarks", desc: "Case Remarks" }
        ];
    }

    render() {
        const { isFetching, caseNotes, token, controlNumber } = this.props;
        if (isFetching) {
            return <MSpinner/>;
        }
        return (
            <div className="details-notes-wrapper">
                <CaseNotesHeader
                    menuItems={this.menuItems}
                    switchMenuItem={this.switchMenuItem}
                    controlNumber={controlNumber}
                    token={token}
                />
                {this.state.currentMenuId == "caseHistory" && <CaseHistoryTabWrapper caseHistory={caseNotes.caseHistory} />}
                {this.state.currentMenuId == "caseRemarks" && <CaseRemarksTabWrapper caseRemarks={caseNotes.caseRemarks} />}
            </div>
        );
    }
}

CaseNotes.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    caseNotes: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    controlNumber: PropTypes.string
};

export default CaseNotes;